/** Drag over checkboxes either adds rows to the selection or removes them. */
export type DragMode = 'select' | 'deselect';

/**
 * Rows between the anchor (where the press started) and the row under the
 * cursor, inclusive, in the order they are displayed. Moving back towards
 * the anchor shrinks the range — rows passed and then left are dropped.
 */
export const dragRange = <K>(
  keys: K[],
  anchorIndex: number,
  currentIndex: number
): K[] => {
  if (keys.length === 0) return [];
  const clamp = (i: number) => Math.max(0, Math.min(keys.length - 1, i));
  const a = clamp(anchorIndex);
  const b = clamp(currentIndex);
  return keys.slice(Math.min(a, b), Math.max(a, b) + 1);
};

/** What the selection would be if the drag were committed now. */
export const previewSelection = <K>(
  selected: K[],
  range: K[],
  mode: DragMode
): K[] => {
  if (mode === 'select') {
    const seen = new Set(selected);
    return [...selected, ...range.filter((k) => !seen.has(k))];
  }
  const dropped = new Set(range);
  return selected.filter((k) => !dropped.has(k));
};
